import { useEffect, useState, useCallback } from "react";
import Modal from "../../../../Components/Base/Modal";
import { influencerlistService } from "../../../../Services";
import { parseInput } from "../../../Constants/AppConstant";
import { storageHandler } from "../../../../Helpers/storage";
import NotSubscribe from "../NotSubscribe";

export default function ModalAddInfToList(props) {
  const {
    toastList,
    setToastList,
    setModal,
    selectedInfluencer,
    handleSearch,
    cartItem,
    closeCartPanel,
    setAuth,
    user,
    NotifModul,
    profiles,
    setModalNotification,
    locationData,
    goToPricing,
    isOpen,
  } = props;

  const [isLoadedList, setIsLoadedList] = useState(false);
  const [listDetails, setListDetails] = useState([]);
  console.log("🚀 ~ ModalAddInfToList ~ listDetails:", listDetails);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [addingToList, setAddingToList] = useState(false);

  const addToast = useCallback(
    (data) => {
      const newToastList = [...toastList];
      newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
      setToastList(newToastList);
    },
    [toastList, setToastList]
  ); // Only depend on toastList and setToastList

  const showAddListModal = () => {
    setModal("addList");
  };

  const addInfluencerToList = async (list) => {
    if (addingToList) return;

    const id = selectedInfluencer.id;
    const inftype = selectedInfluencer.type;
    setAddingToList(true);

    try {
      let option = { inf_user_type: inftype, inf_user_id: id };
      const res = await influencerlistService.assignInfToList(list.id, option);

      if (res.success === true) {
        handleSearch();
        addToast({
          error: false,
          msg: res.message,
        });
        setModal(null);
      }
    } catch (err) {
      if (err.apiResponseStatus != 404) {
        let error = parseInput(err.message);
        addToast({
          error: true,
          msg: error.message,
          id: `${Date.now()}-${toastList.length}`,
        });
      }
    } finally {
      setAddingToList(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const res = await influencerlistService.getAllList();
        if (res.success === true) {
          setListDetails(res.data.data);
          setIsLoadedList(true);
        }
      } catch (err) {
        if (err.apiResponseStatus != 404) {
          let error = parseInput(err.message);
          addToast({
            error: true,
            msg: error.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsLoading(true);
        }
      }
    }
    fetchData();
  }, []);

  // Filter lists based on search term
  const filteredLists = listDetails.filter((list) =>
    list.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  console.log("🚀 ~ ModalAddInfToList ~ filteredLists:", filteredLists);

  let data = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }
  useEffect(() => {
    data.p_f_ids.includes(1);
  }, []);

  return (
    <>
      {data.p_f_ids.includes(1) ? (
        <>
          <Modal addClass="modalCamp" close={props.close}>
            <div className="mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
              {/* Header */}
              <div className="p-6 bg-green-100 border-b border-gray-100">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-800">
                      Add to List
                    </h2>
                    <p className="text-gray-500 mt-1">
                      Add {props.selectedInfluencer?.name || "this influencer"}{" "}
                      to a list
                    </p>
                  </div>
                </div>
              </div>

              {/* Search Bar */}
              <div className="p-5 bg-gray-50 border-b border-gray-100">
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="h-5 w-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    className="block w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="Search your lists..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>

              {/* Lists Container */}
              <div className="max-h-96 overflow-y-auto p-5 bg-gray-50">
                {/* Create New List Card */}
                <div
                  className="flex items-center p-4 mb-4 bg-white rounded-xl shadow-sm border border-gray-200 cursor-pointer hover:border-green-400 hover:shadow-md transition-all duration-200 group"
                  onClick={showAddListModal}
                >
                  <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-lg bg-green-50 text-green-600 group-hover:bg-green-100 transition-colors">
                    <svg
                      className="h-6 w-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </div>
                  <div className="ml-4">
                    <h3 className="font-semibold text-gray-900 group-hover:text-green-700 transition-colors">
                      Create new list
                    </h3>
                    <p className="text-sm text-gray-500">
                      Organize influencers into custom lists
                    </p>
                  </div>
                </div>

                {/* Lists */}
                {filteredLists?.length > 0 ? (
                  filteredLists?.map((list) => (
                    <div
                      key={list.id}
                      className="flex items-center p-4 mb-3 bg-white rounded-xl shadow-sm border border-gray-200 cursor-pointer hover:border-green-400 hover:shadow-md transition-all duration-200 group"
                      onClick={() => !addingToList && addInfluencerToList(list)}
                      style={{
                        opacity: addingToList ? 0.6 : 1,
                        pointerEvents: addingToList ? "none" : "auto",
                      }}
                    >
                      <div className="flex-shrink-0 h-12 w-12 rounded-xl overflow-hidden bg-gray-200 border border-gray-300">
                        <img
                          className="h-full w-full object-cover"
                          src={
                            list.image && list.image_url !== ""
                              ? list.image_url
                              : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                          }
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                          }}
                          alt={list.name}
                        />
                      </div>
                      <div className="ml-4 flex-1 min-w-0">
                        <h3 className="font-semibold text-gray-900 truncate group-hover:text-green-700 transition-colors">
                          {list.name}
                        </h3>
                        <p className="text-sm text-gray-500">
                          {list.count}{" "}
                          {list.count === 1 ? "influencer" : "influencers"}
                        </p>
                      </div>
                      <div className="flex-shrink-0 text-gray-300 group-hover:text-green-500 transition-colors">
                        <svg
                          className="h-5 w-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 5l7 7-7 7"
                          />
                        </svg>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-8 px-4 bg-white rounded-xl border border-dashed border-gray-300">
                    <svg
                      className="mx-auto h-12 w-12 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    <h3 className="mt-3 text-lg font-medium text-gray-900">
                      No lists found
                    </h3>
                    <p className="mt-2 text-gray-500">
                      {searchTerm
                        ? "Try a different search term"
                        : "Get started by creating your first list"}
                    </p>
                    {!searchTerm && (
                      <button
                        className="mt-4 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
                        onClick={showAddListModal}
                      >
                        Create List
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Modal>
        </>
      ) : (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Chat"}
            background={"background_inflist.png"}
          ></NotSubscribe>
        </>
      )}
    </>
  );
}
